import { Link } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';

interface NavigationHighlightBlockProps {
  children: React.ReactNode;
  to: string;
}

export function NavigationHighlightBlock({
  children,
  to,
}: NavigationHighlightBlockProps) {
  return (
    <Flex
      _hover={{
        backgroundColor: 'grey.200',
        cursor: 'pointer',
      }}
      alignItems="center"
      as={Link}
      borderBottomWidth={1}
      borderColor="grey.300"
      borderTopWidth={1}
      direction="row"
      justifyContent="space-between"
      padding="space-16"
      position="relative"
      to={to}
      transition="background-color 0.2s ease-in-out"
    >
      <Flex alignItems="center" direction="row" gap="space-12">
        {children}
      </Flex>
    </Flex>
  );
}
